import apiClient from "../../axios/apiClient";

export const getCityList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CITYLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/City`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_CITYLIST_FULFILLED",
        payload: response.data?.data,
        cityCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_CITYLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveCityData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_CITY_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-City`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_CITY_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_CITY_REJECTED", payload: error.response });
    }
  };
  

  export const getCityListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_CITYLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/City/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_CITYLISTBYID_FULFILLED",
        payload: response.data?.data,
        cityCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_CITYLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateCityData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_CITY_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-City/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CITY_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CITY_REJECTED", payload: error.response });
  }
};


export const updateCityStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_CITY_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-City-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_CITY_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_CITY_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteCityData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_CITY_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-City/${id}`, // Endpoint URL with City ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_CITY_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_CITY_REJECTED", payload: error.response });
  }
};